import clsx from 'clsx';
import { ReactNode } from 'react';
import classes from './ValidationError.module.scss';

export default function ValidationError({
  className,
  error,
  title = 'Please correct the following issues:',
}: ValidationErrorProps) {
  const errors = normalizeError(error);

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className={clsx(classes.root, className)}>
      {title}
      <ul>
        {errors.map((e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={i}>{e}</li>
        ))}
      </ul>
    </div>
  );
}

function normalizeError(error: Error | Error[]): Error[] {
  return Array.isArray(error) ? error : [error];
}

export interface ValidationErrorProps {
  className?: string;
  error: Error;
  title?: string;
}

type Error = ReactNode;
